import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import FirebaseService from "services/FirebaseService";
import {
  showAuthMessage,
  signInWithFacebookAuthenticated,
  signInWithGoogleAuthenticated,
  signUpSuccess,
  showMfaVerification,
  mfaVerificationSuccess
} from "../actions/Auth";
import {
  AUTH_TOKEN,
  EMAIL,
  SIGNIN,
  SIGNIN_WITH_FACEBOOK,
  SIGNIN_WITH_GOOGLE,
  SIGNOUT,
  SIGNUP,
  VERIFY_MFA_CODE,
} from "../constants/Auth";

export function* signInWithFBEmail() {
  yield takeEvery(SIGNIN, function* ({ payload }) {
    const { email, password } = payload;
    try {
      const user = yield call(FirebaseService.signInEmailWithPasswordRequest, email, password);
      if (user.needsMfa) {
        // Mostrar tela de verificação MFA com resolver e email
        yield put(showMfaVerification(user.resolver, user.email));
      } else if (user.message) {
        yield put(showAuthMessage(user.message));
      } else {
        localStorage.setItem(EMAIL, email);
      }
    } catch (err) {
      yield put(showAuthMessage(err.message));
    }
  });
}

export function* signOut() {
  yield takeEvery(SIGNOUT, function* () {
    try {
      const signOutUser = yield call(FirebaseService.signOutRequest);
      if (signOutUser === undefined) {
        localStorage.removeItem(AUTH_TOKEN);
      } else {
        yield put(showAuthMessage(signOutUser.message));
      }
    } catch (err) {
      yield put(showAuthMessage(err.message));
    }
  });
}

export function* signUpWithFBEmail() {
  yield takeEvery(SIGNUP, function* ({ payload }) {
    const { email, password } = payload;
    try {
      const user = yield call(FirebaseService.signUpEmailRequest, email, password);
      if (user.message) {
        yield put(showAuthMessage(user.message));
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid);
        yield put(signUpSuccess(user.user.uid));
      }
    } catch (error) {
      yield put(showAuthMessage(error));
    }
  });
}

export function* signInWithFBGoogle() {
  yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
    try {
      const user = yield call(FirebaseService.signInGoogleRequest);
      if (user.message) {
        yield put(showAuthMessage(user.message));
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid);
        yield put(signInWithGoogleAuthenticated(user.user.uid));
      }
    } catch (error) {
      yield put(showAuthMessage(error));
    }
  });
}

export function* signInWithFacebook() {
  yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
    try {
      const user = yield call(FirebaseService.signInFacebookRequest);
      if (user.message) {
        yield put(showAuthMessage(user.message));
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid);
        yield put(signInWithFacebookAuthenticated(user.user.uid));
      }
    } catch (error) {
      yield put(showAuthMessage(error));
    }
  });
}

export function* verifyMfaCode() {
  yield takeEvery(VERIFY_MFA_CODE, function* ({ payload }) {
    const { code, resolver } = payload;
    try {
      const user = yield call(FirebaseService.resolveMfaRequest, resolver, code);
      if (user.message) {
        yield put(showAuthMessage(user.message));
      } else {
        localStorage.setItem(AUTH_TOKEN, user.user.uid);
        localStorage.setItem(EMAIL, user.user.email);
        yield put(mfaVerificationSuccess(user.user.uid));
      }
    } catch (err) {
      yield put(showAuthMessage(err.message));
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(signInWithFBEmail),
    fork(signOut),
    fork(signUpWithFBEmail),
    fork(signInWithFBGoogle),
    fork(signInWithFacebook),
    fork(verifyMfaCode),
  ]);
}
